import script from "./AddPreferredClientModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddPreferredClientModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddPreferredClientModal.vue?vue&type=style&index=0&id=60fb1488&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60fb1488"]])

export default __exports__